<template>
    <component :is="$route.meta.layout">
        <RouterView />
    </component>
</template>
<script setup>
import  { computed } from 'vue';
import { useRoute } from 'vue-router';
import AdminLayout from './views/layouts/AdminLayout.vue';

const route = useRoute();

const layout = computed(() => {
   switch (route.meta.layout) {
       case 'AdminLayout':
           return AdminLayout;
       default:
           return 'div'
   }
});
</script>
